export const listInvoices = `
   query listInvoices($filter: InvoicesFilterInput, $limit: Int, $nextToken: String) {
       listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              amountDue
              amountPaid
              currency
              customerId
              customerName
              customerEmail
              description
              number
              paid
              periodStart
              periodEnd
              status
              total
              hostedInvoiceUrl
              invoicePdf
              created
           }
           nextToken
       }
   }
`;


export const getInvoice = `
   query getInvoice($id:ID!) {
       getInvoice(id:$id) {
            id
            amountDue
            amountPaid
            currency
            customerId
            customerName
            customerEmail
            description
            number
            paid
            periodStart
            periodEnd
            status
            total
            hostedInvoiceUrl
            invoicePdf
            created
       }
}`;
